/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 18.08.2016.
 */

export const FETCH_NOTIFICATIONS = 'fetch-all-notification';
export const ADD_NOTIFICATION = 'add-notification-about-programme';
export const REMOVE_NOTIFICATION = 'remove-notification-about-programme';

export function FetchNotifications () {

  return {
    type: FETCH_NOTIFICATIONS,
    payload: lh.notifications.getNotifications()
  };
}
export function AddNotification (scheduleEventId) {

  return {
    type: ADD_NOTIFICATION,
    payload: lh.notifications.addNotification(scheduleEventId)
  };
}

export function RemoveNotification (notificationId) {

  return {
    type: REMOVE_NOTIFICATION,
    payload: lh.notifications.removeNotification(notificationId)
  };
}



// WEBPACK FOOTER //
// ./src/actions/notifications/actions-notifications.js